import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getCourseDurationString} from '../../../../../utils/entity/course';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, course, program} = contexts;
  const courseDates = getCourseDurationString(course);

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    buttons: [
      {
        id: 'show_program_changes_button',
        label: i18n.t('shared:show_changes'),
        scheme: 'secondary',
      },
    ],
    subAvatar: actor?.avatar,
    subAvatarPlaceholder: actor?.name,
    title: i18n.t('notifications:membership_expired.title', {
      courseDates,
      programTitle: program?.title,
    }),
  };
};
